import React from 'react';
import {
  Menu,
  useResourceDefinitions,
  useHasDashboard,
  DashboardMenuItem,
  ResourceMenuItem,
} from 'react-admin';
import SettingsIcon from '@mui/icons-material/Settings';
import { Divider, Typography, Box } from '@mui/material';

const HIDDEN_MENU_RESOURCES = ['apartment-prices', 'booking-sources'];

const FilteredResourceMenuItems = () => {
  const resources = useResourceDefinitions();
  if (!resources) return null;
  return (
    <>
      {Object.keys(resources)
        .filter(
          (name) =>
            resources[name].hasList && !HIDDEN_MENU_RESOURCES.includes(name)
        )
        .map((name) => (
          <ResourceMenuItem key={name} name={name} />
        ))}
    </>
  );
};

const AppMenu = () => {
  const hasDashboard = useHasDashboard();
  return (
    <Menu>
      {hasDashboard && <DashboardMenuItem />}
      <FilteredResourceMenuItems />
      <Divider sx={{ my: 1 }} />
      <Box sx={{ px: 2, py: 0.5 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 1 }}>
          Konfiguracja
        </Typography>
      </Box>
      <Menu.Item to="/booking-sources" primaryText="Źródła rezerwacji" leftIcon={<SettingsIcon />} />
    </Menu>
  );
};

export default AppMenu;
